enum ETreeTypeSortOrder {
  Project = 0,
  Folder = 1,
  Experiment = 2,
  Screen = 3,
  ProteinFormulation = 4,
  Seed = 5,
  FragmentScreen = 6,
  SynchrotronTripv4 = 7,
  SearchAnalysis = 8,
}
export default ETreeTypeSortOrder;
